import React, { ReactNode } from "react";
import styled from "styled-components";
import { up } from "styled-breakpoints";
import { Box } from "root/components/design-system";

interface VisibleProps {
  children?: ReactNode;
  className?: string;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xxl?: boolean;
  x3l?: boolean;
}

const VisibleEl = styled(Box)`
  display: var(--sm);

  ${up("md")} {
    display: var(--md);
  }

  ${up("lg")} {
    display: var(--lg);
  }

  ${up("xl")} {
    display: var(--xl);
  }

  ${up("xxl")} {
    display: var(--xxl);
  }

  ${up("x3l")} {
    display: var(--x3l);
  }
`;

export default function Visible({
  children,
  className,
  sm,
  md,
  lg,
  xl,
  xxl,
  x3l,
}: VisibleProps) {
  const display = (view: boolean) => (view ? "initial" : "none");

  return (
    <VisibleEl
      css={`
        --sm: ${display(sm)};
        --md: ${display(md)};
        --lg: ${display(lg)};
        --xl: ${display(xl)};
        --xxl: ${display(xxl)};
        --x3l: ${display(x3l)};
      `}
      className={className}
    >
      {children}
    </VisibleEl>
  );
}
